/* ============================================================
   OrioniX — ori-interactions.js
   Archivo: assets/ori-interactions.js
   Lo carga sections/header-v2.liquid, así que funciona en todas
   las páginas sin tocar theme.liquid.

   1 · Botones: relleno que nace desde el cursor
   2 · Carrito: el contador se actualiza y salta al añadir
   ============================================================ */
(function () {
  'use strict';
  if (window.__oriInteractions) return;
  window.__oriInteractions = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  /* ==========================================================
     1 · RELLENO DESDE EL CURSOR

     A cada botón de la lista se le añade la clase .ori-fx y un
     elemento <i class="ori-fx__fill"> vacío. Ese <i> es el círculo
     que crece. Se usa <i> y no <span> porque Dawn busca el primer
     <span> del botón para escribir "Sold out" o "Add to cart".

     Para añadir un botón nuevo al efecto, pon su selector en el
     grupo que le toque:
       green → botón verde (el relleno es verde oscuro)
       dark  → botón negro
       line  → botón blanco con borde (se rellena de verde)
     ========================================================== */
  var FX = {
    green: [
      '.hero-cta',
      '.promosec-btn',
      '.faq-cta__btn',
      '.catpage-empty__btn',
      '.shopall-empty__btn',
      '.shopall-viewmore',
      '.shopall-endcap__btn',
      '.catfilters-drawer__apply',
      '.orix-btn--primary',
      '.prodpage-purchase__btn--primary',
      '.bundlepage-btn--primary',
      '.product-card-wrapper .quick-add__submit',
      '.catpage-product__cart-btn',
      '.newrel-card__cart-btn',
      '.prodpage-bundle-inline__cta:not(.prodpage-bundle-inline__cta--soldout)',
      '.ohd__cta',
      '.ohd-drawer__cta',
      '.oris-btn:not(.oris-btn--line):not(.oris-btn--dark)',
      '.cb-btn--primary',
      '.orireviews-form__btn',
      '.orireviews-gate__btn'
    ],
    dark: [
      '.prodpage-purchase__btn--secondary',
      '.bundlepage-btn--secondary',
      '.oris-btn--dark',
      '.cb-final__btn'
    ],
    line: [
      '.newrel-viewall',
      '.catpage-filter-btn',
      '.oris-btn--line',
      '.orireviews__more',
      '.shopall-filter-mobile-btn'
    ]
  };

  function prepare() {
    Object.keys(FX).forEach(function (variant) {
      document.querySelectorAll(FX[variant].join(',')).forEach(function (el) {
        if (el.querySelector(':scope > .ori-fx__fill')) return;   // ya preparado
        el.classList.add('ori-fx', 'ori-fx--' + variant);
        var fill = document.createElement('i');
        fill.className = 'ori-fx__fill';
        fill.setAttribute('aria-hidden', 'true');
        el.appendChild(fill);
      });
    });
  }

  /* Guarda en el botón por dónde entró o salió el cursor.
     El CSS usa esas coordenadas como centro del círculo. */
  function place(el, e) {
    var r = el.getBoundingClientRect();
    el.style.setProperty('--fx-x', (e.clientX - r.left) + 'px');
    el.style.setProperty('--fx-y', (e.clientY - r.top) + 'px');
    el.style.setProperty('--fx-s', Math.ceil(Math.hypot(r.width, r.height) * 2.1) + 'px');
  }

  /* Un solo oyente para toda la página, en vez de uno por botón */
  function onPointer(e) {
    var el = e.target.closest && e.target.closest('.ori-fx');
    if (el && !el.contains(e.relatedTarget)) place(el, e);
  }
  document.addEventListener('pointerover', onPointer, { passive: true });
  document.addEventListener('pointerout', onPointer, { passive: true });

  prepare();

  /* Botones que aparecen después (quick add, "view more", reseñas…) */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; prepare(); });
  }).observe(document.body, { childList: true, subtree: true });


  /* ==========================================================
     2 · CARRITO QUE SALTA

     No depende de cómo se añada el producto (Dawn, tus bundles,
     el quick add…): escucha cualquier petición a /cart/add,
     /cart/change, /cart/update o /cart/clear. Cuando termina bien,
     pide /cart.js, actualiza el número y, si subió, lo hace saltar.
     ========================================================== */
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch;

  function currentCount() {
    var badge = document.querySelector('[data-ohd-cart-count]');
    return badge ? parseInt(badge.textContent, 10) || 0 : 0;
  }

  function restart(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;          // reinicia la animación aunque se repita
    el.classList.add(cls);
  }

  function bump(diff) {
    if (reduce) return;
    document.querySelectorAll('[data-ohd-cart]').forEach(function (cart) {
      restart(cart.querySelector('[data-ohd-cart-count]'), 'is-bump');
      restart(cart, 'is-wiggle');
      var plus = document.createElement('span');
      plus.className = 'ohd__cart-plus';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+' + diff;
      cart.appendChild(plus);
      setTimeout(function () { plus.remove(); }, 900);
    });
  }

  function render(count) {
    var before = currentCount();
    document.querySelectorAll('[data-ohd-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-ohd-cart]').forEach(function (cart) {
      cart.setAttribute('aria-label', 'Cart (' + count + ')');
    });
    if (count > before) bump(count - before);
  }

  function refreshCart() {
    nativeFetch.call(window, shopRoot + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { render(cart.item_count); })
      .catch(function () {});
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = String((input && input.url) || input || '');
      var request = nativeFetch.apply(window, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        request.then(function (res) { if (res.ok) refreshCart(); }).catch(function () {});
      }
      return request;            // la respuesta original no se toca
    };
  }
})();
/* ============================================================
   v19 — pegar al FINAL de assets/ori-interactions.js
   3 · Menú que se pinta al hacer clic
   4 · Aparecer al hacer scroll
   ============================================================ */
(function () {
  'use strict';

  /* ── 3 · Clic en el menú: se queda pintado ── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.ohd__nav-link, .ohd__cat');
    if (!link) return;
    link.parentElement.querySelectorAll('.is-painted').forEach(function (x) { x.classList.remove('is-painted'); });
    link.classList.add('is-painted');
  });

  /* ── 4 · Aparecer al hacer scroll ── */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* Rejillas: sus elementos aparecen uno tras otro.
     Añade aquí el selector de cualquier rejilla nueva. */
  var GRIDS = [
    '.catgrid-scroll-inner', '.newrel-grid', '.shopall-grid', '.catpage-grid',
    '.oricg-grid', '.product-grid', '.prodpage__related-track', '.orireviews__grid',
    '.cb-tsts', '.omp-tiers', '.prodpage__grid-info', '.bundlepage-info-grid', '.faq-categories'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    var order = 0;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = Math.min(order++, 8) * 70;   // cascada entre los que entran juntos
      io.unobserve(el);
      el.style.transitionDelay = delay + 'ms';
      el.classList.add('is-in');
      /* Limpieza: el elemento vuelve a sus transiciones normales */
      setTimeout(function () {
        el.removeAttribute('data-reveal');
        el.classList.remove('is-in');
        el.style.transitionDelay = '';
      }, 800 + delay);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function mark(el) {
    if (el.hasAttribute('data-ori-rv')) return;
    el.setAttribute('data-ori-rv', '');
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) return;   // ya en pantalla: no se esconde
    el.setAttribute('data-reveal', '');
    io.observe(el);
  }

  function scan() {
    document.querySelectorAll(GRIDS).forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, mark);
    });
    /* Secciones sin rejilla: aparecen enteras */
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (s) {
      if (!s.querySelector(GRIDS)) mark(s);
    });
  }

  scan();

  /* Productos que llegan después ("View more", filtros…) */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
})();